// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Byte order for combining multi-register values.
 * BigEndianWordFirst: high word at lower address (most common in elevator Modbus).
 * LittleEndianWordFirst: low word at lower address.
 */
export enum ModbusWordOrder {
  BigEndianWordFirst = 0,
  LittleEndianWordFirst = 1,
}
